"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
require("../../scss/_status.scss");
var TruncateTooltip_1 = __importDefault(require("../truncate-tooltip/TruncateTooltip"));
/**
 * @component Status
 * @example
 * <Status text={value} statusColor={StatusColors.success}
 * @param props
 *
 * @param {string} text status text
 * @param {StatusColors} statusColor color of the status - should be one of the StatusColors
 * @param {boolean} isPill should the status be encapsulated?
 * @param {Variant} typographyVariant variant of the typography
 * @param {boolean} wrap whether to wrap the status and text onto new lines if there is not enough space
 * @param {boolean} truncate whether to truncate the text and show a tooltip if there isn't enough space
 */
var Status = function (props) {
    var text = props.text, statusColor = props.statusColor, _a = props.isPill, isPill = _a === void 0 ? false : _a, typographyVariant = props.typographyVariant, _b = props.wrap, wrap = _b === void 0 ? true : _b, _c = props.truncate, truncate = _c === void 0 ? false : _c;
    return (react_1.default.createElement(material_1.Grid, { container: true, className: "status ".concat(isPill ? "status-pill" : ""), justifyContent: "flex-start", alignItems: "center", wrap: wrap ? "wrap" : "nowrap" },
        react_1.default.createElement(material_1.Grid, { item: true, className: "status-dot", style: { backgroundColor: statusColor, minWidth: '0.5em' } }),
        !truncate && (typographyVariant ? (react_1.default.createElement(material_1.Typography, { variant: typographyVariant }, text)) : (react_1.default.createElement(material_1.Grid, { item: true }, text))),
        truncate && (react_1.default.createElement(TruncateTooltip_1.default, { variant: typographyVariant }, text))));
};
exports.default = Status;
